<template>
  <v-container>
    <v-col align="center">
      <v-img :src="`${playerInfo.image}`" height="125px" max-width="125px"></v-img>
      <v-row>
        <v-container>{{ playerInfo.player }}</v-container>
      </v-row>
    </v-col>
  </v-container>
</template>

<script>

export default {
  name: "WaitingPlayer",
  props: {
    playerInfo: Object,
  },
  data() {
    return {
    };
  },
};
</script>
